/* eslint-disable complexity */
/* eslint-disable max-statements */

import $ from 'jquery';
import Backbone from 'backbone';
import Handlebars from 'handlebars';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import Moment from 'moment';
import {findLast, forEach, whereEq, pipe} from 'ramda';

import {messageHandler} from '@sinclair-digital/stl-common/src/sinclair/sinclair.uiTools';
import {getFetch, withMainLoader} from '@sinclair-digital/stl-common/src/sinclair/sinclair.ajax';
import newNodeTemplate from 'templates/sites/newNodeTemplate.hbs';
import templateSelectRightPanelTemplate from 'templates/sites/templateSelectRightPanel.hbs';
import metaKeywordTemplate from 'templates/sites/metaKeyword.hbs';
import presentationNodeTemplate from 'templates/sites/presentationNodeTemplate.hbs';
import siteTreeTemplate from 'templates/sites/siteTreeTemplate.hbs';
import SiteTreeModel from 'models/properties/siteTreeModel';
import PresentationModel from 'models/properties/presentationModel';
import SiteSectionPropertyModel from 'models/properties/siteSectionPropertyModel';
import PresentationReferenceCollection from 'collections/properties/presentationReferenceCollection';
import NavManagerView from 'views/properties/navManagerView';
import * as analytics from 'analytics/property';
import {getModuleButtons} from 'modules';
import {bindAllMethods} from '@sinclair-digital/stl-common/src/backboneHelpers';
import {getFeatureFlag} from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/featureFlags';

import {SiteTreeRightTypesPanel, default as SiteTreeRightPanel} from './SiteTreeRightPanel';

// publishThenPromise :: SiteSectionPropertyModel -> () -> Promise(SiteSectionPropertyModel)
const publishThenPromise = model => () => {
    return new Promise((resolve, reject) => {
        model.publish(Object.assign({success: resolve, failure: reject}, withMainLoader));
    });
};

// :: Presentation -> Presentation
const sortHomeFirst = ({name: name1}, {name: name2}) => {
    const sortName1First = -1;
    const sortName2First = 1;
    const unchanged = 0;

    if (name1 === 'Home') {
        return sortName1First;
    } else if (name2 === 'Home') {
        return sortName2First;
    } else {
        return unchanged;
    }
};

// :: SiteTree -> SiteTree
export const sortPresentations = siteTree => ({
    ...siteTree,
    presentations: siteTree.presentations.sort(sortHomeFirst),
});

const parseCustomJsonField = (customJsonField) => {
    if (customJsonField === '') {
        return null;
    }

    const parsedJson = JSON.parse(customJsonField);
    return _.isEmpty(parsedJson) ? null : parsedJson;
};


const SiteTreeView = Backbone.View.extend({
    debuggingName: 'Site Tree View',
    sdaPageTitle: 'site tree',
    el: '#admin-main',
    navId: 'admin-properties-tab',
    model: null,
    sectionModel: null,
    presentationReferenceCollection: null,
    presentationModel: null,
    siteTreeUuid: null,
    navigationModel: null,
    searchNavigationNodesSeed: null,
    searchNavigationNodesTimer: null,
    template: siteTreeTemplate,
    subViews: [],
    events: {
        'click #sda-add-node, .sda-add-sub-node': '_addNewNodeHandler',
        'click #sda-node-cancel-btn': '_cancelNodeHandler',
        'click #sda-node-save-btn': '_saveNodeHandler',
        'click #sda-node-publish-btn': '_publishNodeHandler',
        'click .sda-presentation-unpublish-btn': '_unpublishNodeHandler',
        'change #sda-node-type': '_selectNodeTypeHandler',
        'click .sda-tree-node main': '_editNodeHandler',
        'click #sda-change-template-link': '_openTemplateSelectPanelHandler',
        'click #sda-template-cancel-btn': '_closeTemplateSelectHandler',
        'click #sda-template-save-btn': '_saveTemplateSelectHandler',
        'click #sda-seo-done-btn': '_updateSeoHandler',
        'click #sda-seo-cancel-btn': '_cancelSeoPanel',
        'click .sda-seo-meta-keyword>i': '_removeMetaKeywordHandler',
        'keyup #property-section-seo-meta-keywords': '_seoMetaKeywordKeyupHandler',
        'click #property-section-seo-meta-keyword-add': '_seoMetaMaybeAddKeyword',
        'click .sda-template': '_selectTemplateHandler',
        'keyup #sda-node-name': '_updateNodeUrl',
        'focusout #sda-node-url, #sda-presentation-url': '_normalizeNodeUrl',
        'click a.sda-footer-open-btn.card-ellipsis': '_openNodeOptions',
        'click a.sda-footer-close-btn.card-ellipsis': '_closeNodeOptions',
        'click .sda-sitetree-preview': '_previewSection',
        'mouseenter #sda-template-right-panel': '_setFocusTemplatePanel',
        'click #sda-site-publish-btn': '_publishSite',
        'click #sda-site-unpublish-btn': '_unpublishSite',

        // NAVIGATION MANAGER EVENTS
        'click #sda-nav-manager-btn': '_renderNavManagerView',
    },
    initialize(opts) {
        this.appContext = opts.appContext;
        bindAllMethods(this);
        this._registerHandlebarHelpers();

        if (opts.id) {
            this.model = new SiteTreeModel({siteUuid: opts.id});
            this.model
                .fetch(withMainLoader)
                .then(() => this.render());
            this.propertyUuid = opts.id;
        } else {
            this.routeChanger('property', 'error', 'Error retrieving property');

            return false;
        }

        this.presentationReferenceCollection = new PresentationReferenceCollection();

        return this;
    },
    _getSiteSlug() {
        return this.model.get('parentSite').url.replace(/.\w+$/, '');
    },
    render() {
        this.siteTreeUuid = this.model.get('parentSite').uuid;
        this.rootNodeUuid = this.model.get('uuid');
        const site = this.model.toJSON();
        const template = pipe(
            sortPresentations,
            this.template,
        )(site);

        this.$el.html(template).sdaInitWidgets();
        this.presentationReferenceCollection.reset();
        this.presentationReferenceCollection.fetch(this._getSiteSlug());

        analytics.viewSiteMap(this.siteTreeUuid);

        return this;
    },

    _buildRightPanelOptions() {
        const canEditProperty = this.permissionGranted('section.edit', this.propertyUuid);
        return {
            appContext: this.appContext,
            //Maybe move these blockers to subview?
            hasRightPanelSubsection: {
                template: canEditProperty,
                linkedPackage: canEditProperty,
            },
            isRightPanelFieldReadonly: {
                name: !canEditProperty,
                URL: !canEditProperty,
                redirectURL: !canEditProperty,
                markup: !canEditProperty,
            },
        };
    },

    _showRightPanel($el, options) {
        const presentationModel = this.presentationModel ? this.presentationModel.toJSON() : {};
        const sectionModel = this.sectionModel;
        const indexPresentation = sectionModel ? sectionModel.get('indexPresentation').toJSON() : {};

        // Compile all of the sources of data for the left bar
        const panelOpts = Object.assign(
            this._buildRightPanelOptions(),
            {
                presentationModel: this.presentationModel,
                sectionModel,
                indexPresentation,
                propertyUuid: this.propertyUuid,
            },
            presentationModel.presentationReference,
            presentationModel,
            options,
        );

        // Now do a little cleanup
        panelOpts.siteSlug = this._getSiteSlug();
        if (panelOpts.isNewNode) {
            delete panelOpts.name;
        }
        ReactDOM.render(<SiteTreeRightPanel {...panelOpts} />, $el[0]);

        $el.sdaInitWidgets();

        presentationModel.uuid
            ? analytics.focusOnPresentation(`presentation:${presentationModel.uuid}`)
            : analytics.focusOnSection(`section:${sectionModel.uuid}`);
    },

    // NODE SELECTION
    _addNewNodeHandler(e) {
        const $caller = $(e.target);
        const $node = $caller.closest('.sda-tree-node');
        const $panel = $('#sda-node-right-panel');
        const parentUuid = this._getParentUuid($node);
        const isRootNode = parentUuid === this.rootNodeUuid;
        const panelOpts = {
            type: 'section',
            isNewNode: true,
            parentUuid,
            isRootNode,
        };

        analytics.addSection();

        this._clearNodeSelection();

        if ($caller.hasClass('sda-add-sub-node')) {
            $caller
                .closest('li')
                .children('.sda-sitetree-subsection-list')
                .append(newNodeTemplate);
        } else {
            $('#sda-sitetree-section-list').append(newNodeTemplate);
        }

        this.sectionModel = new SiteSectionPropertyModel();
        this.presentationModel = new PresentationModel();

        // open right panel with blank/default info
        $panel.addClass('panel-open');
        this._showRightPanel($panel, panelOpts);
        $panel.find('.panel-header').attr('data-new-node', 'true');

        // scroll to new node after animation
        setTimeout(function() {
            $('.sda-sitetree-cardtree').scrollTop(0);
            if ($('#sda-new-node').length) {
                $('.sda-sitetree-cardtree').scrollLeft($('#sda-new-node').position().left + 150);
            }
        }, 200);
    },

    showLoadingRightPannel() {
        $('#sda-node-right-panel').addClass('panel-open');
        const rightPanel = $('#sda-node-right-panel');
        this._showRightPanel(rightPanel, {isLoading: true});
    },

    _editNodeHandler(e) {
        if (!this.permissionGranted('section.edit', this.propertyUuid)) {
            return false;
        }

        const that = this;
        const $caller = $(e.target);
        const $node = $caller.closest('.sda-tree-node');
        const type = $node.attr('data-node-type');
        const nodeId = $node.attr('data-node-uuid');
        const presentationKey = $node.attr('data-template-id');
        const presentationName = that.presentationReferenceCollection.getNameFromKey(presentationKey);
        const nodePresentation = $node.attr('data-presentation-uuid');
        const parentUuid = that._getParentUuid($node.closest('ul').siblings('.sda-tree-node'));
        const isRootNode = parentUuid === that.rootNodeUuid;
        const sectionOpts = {
            type: 'section',
            complete() {},
            before() {
                that.showLoadingRightPannel();
            },
            success(sectionModel) {
                const indexPresentationModel = sectionModel.get('indexPresentation');

                sectionModel.set({
                    isNewNode: false,
                    type,
                    parentUuid: that._getParentUuid($node.closest('ul').siblings('.sda-tree-node')),
                    presentationUuid: nodePresentation,
                    templateId: presentationKey,
                    isRootNode,
                });

                if (indexPresentationModel) {
                    that._refreshSeoPanel(indexPresentationModel);
                }

                const rightPanel = $('#sda-node-right-panel');
                that._showRightPanel(rightPanel, sectionModel.toJSON());

                if (presentationKey) {
                    $('#sda-change-template-link .state-info').text(presentationName);
                }
            },
        };

        const presentationOpts = {
            type: 'page',
            complete() {},
            before() {
                that.showLoadingRightPannel();
            },
            success(presentationModel) {
                presentationModel.set({
                    isNewNode: false,
                    type,
                    parentUuid: that._getParentUuid($node.closest('ul').siblings('.sda-tree-node')),
                    isRootNode,
                });

                const rightPanel = $('#sda-node-right-panel');
                const templateProps = Object.assign(
                    {
                        rootPresentation: $('.sda-tree-section-site-level').has($node),
                    },
                    presentationModel.toJSON(),
                );

                templateProps.presentationUuid = templateProps.uuid;
                templateProps.uuid = templateProps.parentUuid;
                that._showRightPanel(rightPanel, templateProps);

                if (presentationModel && presentationModel.attributes && presentationModel.get('pathUrl')) {
                    $('#sda-node-url-select').val(presentationModel.get('pathUrl'));
                }

                if (presentationModel && presentationModel.attributes && presentationModel.get('templateId')) {
                    $('#sda-change-template-link .state-info').text(presentationName);
                }
            },
        };

        that._clearNodeSelection();

        $node.addClass('sda-node-selected').attr('data-parent-node-uuid', parentUuid);

        // call either section-property or presentation endpoint based on node type
        if (type === 'section' || type === 'subsection') {
            that.sectionModel = new SiteSectionPropertyModel({
                uuid: nodeId,
            });
            that.sectionModel.fetch(getFetch(sectionOpts));
        } else if (type === 'content' || type === 'presentation' || type === 'page') {
            that.presentationModel = new PresentationModel({
                uuid: nodeId,
            });
            that.presentationModel.fetch(getFetch(presentationOpts));
        }
    },

    _cancelNodeHandler() {
        $('#sda-node-right-panel').removeClass('panel-open');
        this._clearNodeSelection();
    },

    _selectNodeTypeHandler(e) {
        const $caller = $(e.target);
        const type = $caller.val();
        const $node = $('#sda-new-node .sda-tree-node');
        const parentUuid = this._getParentUuid($node.closest('ul').siblings('.sda-tree-node'));
        const isRootNode = parentUuid === this.rootNodeUuid;
        const opts = Object.assign(this._buildRightPanelOptions(), {
            type,
            isNewNode: true,
            isRootNode,
        });

        $node.attr('data-node-type', type);
        $('#sda-node-right-panel')
            .find('.panel-header')
            .attr('data-node-type', type);

        const rightPanel = $('#sda-node-right-panel-types');
        ReactDOM.render(<SiteTreeRightTypesPanel {...opts} />, rightPanel[0]);
        rightPanel.sdaInitWidgets();
    },

    _showSelectedTemplate(nodeTemplateId) {
        const presentationReference = this.presentationReferenceCollection.findWhere({key: nodeTemplateId});
        $('#sda-change-template-link .state-info').text(presentationReference.name);
        $(`#sda-template-right-panel .sda-template[data-template-id="${presentationReference.key}"]`).addClass(
            'sda-template-selected',
        );
    },

    _clearNodeSelection() {
        $('#sda-new-node').remove();
        $('.sda-node-selected').removeClass('sda-node-selected');
        $('.sda-show-options').removeClass('sda-show-options');

        this.presentationModel = null;
        this.sectionModel = null;

        this._closeTemplateSelectHandler();
    },

    _getParentUuid($node) {
        if ($node.length && $node.attr('data-node-uuid')) {
            return $node.attr('data-node-uuid');
        } else {
            return this.rootNodeUuid;
        }
    },
    _unpublishNodeHandler(e) {
        const uuid = this.$(e.target)
            .closest('.sda-tree-node')
            .data('node-uuid');

        analytics.unpublishSection(uuid);

        if (uuid) {
            return new SiteSectionPropertyModel({uuid})
                .unpublish()
                .then(this._sectionSuccessHandler.bind(this, {attributes: {uuid}}, {}));
        }

        messageHandler('error', 'No valid uuid found for that property');

        return $.Deferred().reject('No valid uuid found for that property');
    },
    _publishNodeHandler() {
        const nodeType = this.$('#sda-node-right-panel')
            .find('.panel-header')
            .attr('data-node-type');

        if (nodeType === 'section') {
            this.sectionModel.setPublishAuthorizationDate(Moment.utc().valueOf());
            analytics.publishSection(this.sectionModel.get('uuid'));

            return this._saveSectionNodeHandler(publishThenPromise(this.sectionModel));
        } else if (nodeType === 'presentation') {
            this.presentationModel.setPublishAuthorizationDate(Moment.utc().valueOf());

            analytics.publishPresentation(this.presentationModel.get('uuid'));

            return this._savePresentationNodeHandler().then(this.presentationModel.publish.bind(this, withMainLoader));
        }

        messageHandler('error', 'Error saving page', 'That page is not of a supported type', `Type: ${nodeType}`);

        return $.Deferred().reject('invalid node type');
    },
    _saveNodeHandler() {
        const $panelHeader = $('#sda-node-right-panel').find('.panel-header');
        const nodeType = $panelHeader.attr('data-node-type');

        switch (nodeType) {
            case 'section':
                this._saveSectionNodeHandler();
                break;
            case 'topical':
                messageHandler('error', 'saving topical node not yet available');
                break;
            case 'presentation':
                this._savePresentationNodeHandler();
                break;
            case 'alias':
                messageHandler('error', 'saving alias node not yet available');
                break;
            default:
                messageHandler('error', 'Error saving page');
                break;
        }
    },

    // eslint-disable-next-line max-statements
    _saveSectionNodeHandler(promiseCallback) {
        const $panel = $('#sda-node-right-panel');
        const $panelHeader = $panel.find('.panel-header');
        let customJson = null;
        if (getFeatureFlag('useCustomJson')) {
            try {
                customJson = parseCustomJsonField($panel.find('#sda-node-custom-json').val());
            } catch {
                messageHandler('error', 'We were unable to successfully parse the customJson Field');
                return null;
            }
        }

        const modelParameters = {
            name: $panel.find('#sda-node-name').val(),
            pathUrl: $panel.find('#sda-node-url').val(),
            adZone: $panel.find('#sda-node-ad-zone').val(),
            parentSection: {type: 'SectionProperty', uuid: $panelHeader.attr('data-parent-uuid')},
            parentSite: {uuid: this.siteTreeUuid},
            templateId: $panelHeader.attr('data-template-id') || 'Blank_Template',
            parentChannelProperty: {type: 'WebSite', uuid: this.siteTreeUuid},
            data: {
                injectedMarkup: $panel.find('#sda-node-injected-markup').val(),
                customJson,
            },
            savedDate: Moment.utc().valueOf(),
        };

        if (getFeatureFlag('nonTargetableSection:enabled')) {
            modelParameters.targetable = $panel.find('#sda-node-targetable').attr('aria-checked') === 'true';
        }

        if (!modelParameters.name || !modelParameters.pathUrl) {
            if (!modelParameters.name) {
                $panel.find('#sda-node-name').sdaError('Required');
            }
            if (!modelParameters.pathUrl) {
                $panel.find('#sda-node-url').sdaError('Required');
            }
        } else {
            const options = {
                type: 'PUT',
                successMessage: 'Page updated',
                success: (response, data) => {
                    if ('function' === typeof promiseCallback) {
                        return promiseCallback().then(cbResponse => this._sectionSuccessHandler(cbResponse, data));
                    }
                    return this._sectionSuccessHandler(response, data);
                },
                errorMessage: 'Error saving page',
            };

            if ($panelHeader.data('new-node')) {
                options.type = 'POST';
                options.successMessage = 'Page created';
                const slug = this._getSiteSlug();
                this.sectionModel.get('indexPresentation').get('presentationReference').siteSlug = slug;
            } else {
                modelParameters.uuid = $panelHeader.attr('data-node-uuid');
            }

            return this.sectionModel.save(modelParameters, getFetch(options));
        }
        return null;
    },

    _savePresentationNodeHandler() {
        const that = this;
        const $panel = $('#sda-node-right-panel');
        const $panelHeader = $panel.find('.panel-header');
        const isNewNode = $panelHeader.data('new-node');
        const nodeParentId = $panelHeader.attr('data-parent-uuid');
        const nodeName = $panel.find('#sda-node-name').val();
        const nodeUrlSelected = $panel.find('#sda-node-url-select').val();
        const nodeAdZone = $panel.find('#sda-node-ad-zone').val();
        const nodeTemplateId = $panelHeader.attr('data-template-id');
        const presentationId = $('#sda-change-template-link')
            .find('[data-presentation-uuid]')
            .data('presentation-uuid');
        const postOpts = {
            type: 'POST',
            successMessage: 'Page created',
            success(response, data) {
                that._presentationSuccessHandler(response, data);
            },
            errorMessage: 'Error saving page',
        };
        const putOpts = {
            type: 'PUT',
            successMessage: 'Page updated',
            success(response, data) {
                that._presentationSuccessHandler(response, data);
            },
            errorMessage: 'Error saving page',
        };

        const injectedMarkup = $panel.find('#sda-node-injected-markup').val();
        let customJson = null;
        if (getFeatureFlag('useCustomJson')) {
            try {
                customJson = parseCustomJsonField($panel.find('#sda-node-custom-json').val());
            } catch {
                messageHandler('error', 'We were unable to successfully parse the customJson Field');
                return null;
            }
        }

        let nodeUrl = $panel.find('#sda-presentation-url').val();
        let nodeContentType = $panelHeader.attr('data-content-type');

        if (!nodeUrl && nodeUrlSelected) {
            nodeUrl = nodeUrlSelected;
        }

        if (!nodeName || (!nodeUrl && nodeContentType !== 'index')) {
            if (!nodeName) {
                $panel.find('#sda-node-name').sdaError('Required');
            }
            if (!nodeUrl) {
                $panel.find('#sda-presentation-url').sdaError('Required');
                $panel.find('#sda-url-select').sdaError('Required');
            }
        } else {
            if (nodeUrl === '/story' || nodeUrlSelected === '/story') {
                nodeContentType = 'content-story';
            } else if (nodeUrl === '/gallery' || nodeUrlSelected === '/gallery') {
                nodeContentType = 'content-story-gallery';
            } else if (nodeUrl === '/video' || nodeUrlSelected === '/video') {
                nodeContentType = 'content-story-video';
            } else if (nodeUrl === '/' || nodeUrl === '') {
                nodeContentType = 'index';
            } else if (nodeUrl === '/bio' || nodeUrlSelected === '/bio') {
                nodeContentType = 'content-biography';
            } else if (nodeUrl === '/more' || nodeUrlSelected === '/more') {
                nodeContentType = 'more';
            } else {
                nodeContentType = 'static';
            }

            that.presentationModel.setName(nodeName);
            that.presentationModel.setTemplateId(nodeTemplateId);
            that.presentationModel.setPathUrl(nodeUrl);
            that.presentationModel.setPresentationCategory(nodeContentType);
            that.presentationModel.setAdzone(nodeAdZone);
            that.presentationModel.setPresentationSection(nodeParentId);
            that.presentationModel.setCustomHtml({injectedMarkup, customJson});

            if (isNewNode) {
                const slug = that._getSiteSlug();
                that.presentationModel.get('presentationReference').siteSlug = slug;
                return that.presentationModel.save({}, getFetch(postOpts));
            } else {
                that.presentationModel.setModelId(presentationId);
                return that.presentationModel.save({}, getFetch(putOpts));
            }
        }
    },

    // TEMPLATE SELECTION
    _openTemplateSelectPanelHandler() {
        const that = this,
            $templatePanel = $('#sda-template-right-panel'),
            $nodePanel = $('#sda-node-right-panel').find('.panel-header'),
            presentationUuid = $nodePanel.attr('data-presentation-uuid'),
            isNewNode = $nodePanel.data('new-node'),
            nodeType = $nodePanel.attr('data-node-type'),
            presentationKey = $nodePanel.attr('data-template-id'),
            pageTemplates = that.presentationReferenceCollection.toJSON(),
            opts = {
                presentationUuid,
                pageTemplates,
                selectedPresentationKey: presentationKey,
            },
            populateTemplate = function() {
                $templatePanel.addClass('right-panel-visible');
                $templatePanel.html(templateSelectRightPanelTemplate(opts));

                if (presentationKey) {
                    $('#sda-template-right-panel .sda-template[data-template-id="' + presentationKey + '"]').addClass(
                        'sda-template-selected',
                    );
                }

                setTimeout(function() {
                    $templatePanel.addClass('panel-open');
                    $('#sda-template-right-panel .panel-section-body .sda-template:first-child').focus();
                }, 20);
            };

        if (isNewNode && nodeType === 'section') {
            messageHandler('info', 'Please save page before picking a template');
        } else {
            populateTemplate();
        }
    },

    _selectTemplateHandler(e) {
        const $caller = $(e.target).closest('a');
        const templateId = $caller.attr('data-template-id');
        const templateName = $caller.attr('data-template-name');
        const $panel = $('#sda-template-right-panel').children('.panel-main');

        $('.sda-template-selected').removeClass('sda-template-selected');
        $caller.addClass('sda-template-selected');
        $panel.attr('data-selected-template-id', templateId).attr('data-selected-template-name', templateName);
    },

    _closeTemplateSelectHandler() {
        const $templatePanel = $('#sda-template-right-panel');

        $templatePanel.removeClass('panel-open');

        setTimeout(function() {
            $templatePanel.removeClass('right-panel-visible');
        }, 200);
    },

    _saveTemplateSelectHandler() {
        const that = this,
            $nodePanel = $('#sda-node-right-panel').find('.panel-header'),
            $templatePanel = $('#sda-template-right-panel').children('.panel-main'),
            presentationKey = $templatePanel.attr('data-selected-template-id'),
            presentationName = $templatePanel.attr('data-selected-template-name'),
            presentationReference = that.presentationReferenceCollection.findWhere({key: presentationKey}),
            presentationModel = that.sectionModel ? that.sectionModel.get('indexPresentation') : that.presentationModel;

        $nodePanel.attr('data-template-id', presentationKey);
        $('#sda-change-template-link .state-info').text(presentationName);

        presentationModel.set('presentationReference', presentationReference);

        analytics.changePresentation(presentationKey);

        that._closeTemplateSelectHandler();
    },

    _setFocusTemplatePanel(e) {
        const $caller = $(e.target),
            $panel = $caller.closest('#sda-template-right-panel'),
            $selectedTemplate = $panel.find('.sda-template-selected'),
            hasSelectedTemplate = $selectedTemplate.length > 0;

        if (hasSelectedTemplate) {
            $selectedTemplate.click();
        } else {
            $panel.find('.panel-section-body > a:first-child').click();
        }
    },

    _updateSeoHandler() {
        const that = this,
            pageTitle = $('#property-section-seo-title').val(),
            pageDescription = $('#property-section-seo-description').val(),
            pageKeywords = that._getMetaKeywordsForSave();

        that.sectionModel.get('indexPresentation').set({
            pageTitle,
            pageDescription,
            pageKeywords,
        });

        analytics.modifySeo(that.sectionModel.get('uuid'));

        that._closeSeoPanel();
    },
    _cancelSeoPanel() {
        this._refreshSeoPanel();
        this._closeSeoPanel();
    },
    _loadMetaKeywords(keywords) {
        const that = this;

        $('#sda-seo-meta-keyword-list').empty();
        if (keywords) {
            forEach(that._addMetaKeyword, keywords);
        }

        return that;
    },
    _addMetaKeyword(keyword) {
        $('#sda-seo-meta-keyword-list').append(metaKeywordTemplate(keyword));
    },
    _removeMetaKeywordHandler(e) {
        $(e.target)
            .closest('li')
            .remove();
    },
    _getMetaKeywordsForSave() {
        return $('#sda-seo-meta-keyword-list')
            .children()
            .toArray()
            .map(el => el.dataset.keyword);
    },
    _seoMetaKeywordKeyupHandler(e) {
        const enter = 13;

        if (e.which === enter) {
            this._seoMetaMaybeAddKeyword();
        }
    },
    _seoMetaMaybeAddKeyword() {
        const $input = $('#property-section-seo-meta-keywords');
        const val = $input
            .val()
            .trim()
            .toLowerCase();
        $input.val('');

        if ($('.sda-seo-meta-keyword[data-keyword="' + val + '"]').length) {
            messageHandler('info', 'Keyword already exists');
            return;
        }

        this._addMetaKeyword(val);
    },
    _closeSeoPanel() {
        $('#sda-seo-right-panel').close();
    },
    _refreshSeoPanel(indexPresentationModel) {
        try {
            const model = indexPresentationModel || this.sectionModel.get('indexPresentation');
            $('#property-section-seo-title').val(model.get('pageTitle'));
            $('#property-section-seo-description').val(model.get('pageDescription'));
            this._loadMetaKeywords(model.get('pageKeywords'));
        } catch (e) {
            console.warn('Error refreshing SEO Panel: %o', e);
        }
    },
    _previewSection(e) {
        const $caller = $(e.target);
        const node = $caller.closest('.sda-tree-node');
        const sectionId = node.data('is-root-node') ? node.data('root-section-uuid') : node.data('node-uuid');
        const parentSite = this.model.get('parentSite');
        const siteId = parentSite.uuid;

        const isV2Site = parentSite.packageTypes.includes('SHOW');
        // TODO: Button should specify compatible types somehow - ADM 10.30.17
        const {href: route = 'property'} =
            (isV2Site
                ? findLast(
                    whereEq({
                        buttonType: 'section-action',
                        id: 'sda-sitetree-preview',
                    }),
                    getModuleButtons(),
                )
                : {}) || {};

        this.routeChanger(`${route}/${siteId}/${sectionId}/preview`);
    },

    _updateNodeUrl(e) {
        const that = this,
            urlStr = $(e.target)
                .val()
                .toLowerCase(),
            $nodeUrlInput = $('#sda-node-url');

        $nodeUrlInput.val(that._normalizeUrlString(urlStr));

        if ($nodeUrlInput.hasClass('sda-error')) {
            $nodeUrlInput.sdaRemoveError();
        }
    },

    _normalizeNodeUrl(e) {
        const that = this,
            $caller = $(e.target),
            urlStr = $(e.target)
                .val()
                .toLowerCase(),
            normalizedString = that._normalizeUrlString(urlStr);

        if (normalizedString === '/' || normalizedString === '') {
            $caller.val('');
        } else {
            $caller.val(normalizedString);
        }

        if ($caller.hasClass('sda-error')) {
            $caller.sdaRemoveError();
        }
    },

    _normalizeUrlString(str) {
        return (
            '/' +
            str
                .replace(/[^\w\d\-_ ]/g, '')
                .replace(/^\s+|\s+$/g, '')
                .replace(/[ ]/g, '-')
                .replace(/-{2,}/g, '-')
        );
    },
    _sectionSuccessHandler({attributes: {uuid} = {}}) {
        const that = this;

        if (uuid) {
            analytics.saveSection(uuid);
        }

        if (that.siteTreeUuid) {
            that._cancelNodeHandler();
            that.model = new SiteTreeModel({siteUuid: that.siteTreeUuid});
            that.model.fetch(withMainLoader).then(that.render);
        } else {
            that.routeChanger('property', 'error', 'Error retrieving property');

            return false;
        }

        return that;
    },

    _presentationSuccessHandler(response) {
        const that = this;

        analytics.savePresentation(response.attributes.uuid);

        if (that.siteTreeUuid) {
            that.model = new SiteTreeModel({siteUuid: that.siteTreeUuid});
            that.model.fetch(withMainLoader).then(that.render);
        } else {
            that.routeChanger('property', 'error', 'Error retrieving property');

            return false;
        }

        return that;
    },

    _openNodeOptions(e) {
        const that = this,
            $node = $(e.target).closest('.sda-tree-node'),
            parentUuid = that._getParentUuid($node.closest('ul').siblings('.sda-tree-node'));

        $('.sda-show-options').removeClass('sda-show-options');
        $node.addClass('sda-show-options').attr('data-parent-node-uuid', parentUuid);

        e.stopPropagation();
    },

    _closeNodeOptions(e) {
        const $node = $(e.target).closest('.sda-tree-node');

        $node.removeClass('sda-show-options');
    },
    _statusChangeRequest(action) {
        return this.model[action]()
            .then(() => this.model.fetch(withMainLoader).then(this.render))
            .then(messageHandler.bind(this, 'success', `Site status set to "${action}ed"`, ''))
            .fail(messageHandler.bind(this, 'error', 'Site status change failed', ''));
    },
    _publishSite() {
        analytics.publishSite(this.siteTreeUuid);
        return this._statusChangeRequest('publish');
    },
    _unpublishSite() {
        analytics.unpublishSite(this.siteTreeUuid);
        return this._statusChangeRequest('unpublish');
    },
    // NAVIGATION MANAGER

    _renderNavManagerView() {
        if (this.navManagerView) {
            this.navManagerView.render({
                id: this.propertyUuid,
                el: '#sda-nav-manager-fly-over',
                parentView: this,
            });
        } else {
            this.navManagerView = new NavManagerView({
                id: this.propertyUuid,
                el: '#sda-nav-manager-fly-over',
                parentView: this,
            });

            this.subViews.push(this.navManagerView);
        }
    },

    // TEMPORARILY REMOVED
    _doubleClickHandler(e) {
        let section = {},
            indexPresentation = null;
        const that = this,
            $node = $(e.target).attr('data-node-uuid') ? $(e.target) : $(e.target).parents('*[data-node-uuid]:first'),
            opts = {
                success(data, response) {
                    indexPresentation = that._getPresentationFromSectionByCategory(section, 'index');
                    if (indexPresentation != null) {
                        that.routeChanger('builder/' + indexPresentation.uuid);
                        return;
                    }
                    that._createSectionDefaultPresentation(data, response, this);
                },
                complete() {},
            };

        // Ignore doubleclicks if the section hasn't been created yet
        if ($('.sda-edit-node-btn').length || $('.sda-create-node-btn').length) {
            return;
        }
        if ($node.attr('data-node-type') === 'presentation') {
            that.routeChanger('builder/' + $node.attr('data-node-uuid'));
        } else {
            section = new SiteSectionPropertyModel({
                uuid: $node.attr('data-node-uuid'),
            });
            section.fetch(getFetch(opts));
        }
        e.preventDefault();
    },

    // HANDLEBARS HELPERS

    _registerHandlebarHelpers() {
        const that = this;

        Handlebars.registerHelper('getNodeType', function(type) {
            let nodeTypeString = '';

            switch (type) {
                case 'section':
                    nodeTypeString = 'Section Page';
                    break;
                case 'presentation':
                    nodeTypeString = 'Content Page';
                    break;
                case 'Topical':
                    nodeTypeString = 'Topical Page';
                    break;
                case 'Alias':
                    nodeTypeString = 'Alias';
                    break;
                default:
                    nodeTypeString = 'Error';
            }

            return nodeTypeString;
        });

        Handlebars.registerHelper('getStatus', function(status) {
            if (status) {
                return status.toLowerCase();
            } else {
                return 'draft';
            }
        });

        Handlebars.registerHelper('getNonIndexPresentations', function(options) {
            const pages = _.reject(options, function(page) {
                return page && page.presentationCategoryType === 'Index';
            });

            return presentationNodeTemplate(pages);
        });

        Handlebars.registerHelper('getPropertyUuid', function() {
            return that.propertyUuid;
        });
    },
});

export default SiteTreeView;
